import gql from "graphql-tag";

export const markGameAsPlayedGQL = gql`
  mutation MarkGameAsPlayed($gameId: String!) {
    markGameAsPlayed(gameId: $gameId) {
      message
    }
  }
`;

export const abandonGameQueueSlotGQL = gql`
  mutation AbandonGameQueueSlot($input: AbandonGameQueueSlotInput!) {
    abandonGameQueueSlot(input: $input) {
      message
    }
  }
`;

export const addGamesToLibraryGQL = gql`
  mutation AddGamesToLibrary($input: AddGamesToLibraryInput!) {
    addGamesToLibrary(input: $input) {
      message
    }
  }
`;

export const removeGamesFromLibraryGQL = gql`
  mutation RemoveGamesFromLibrary($input: RemoveGamesFromLibraryInput!) {
    removeGamesFromLibrary(input: $input) {
      message
    }
  }
`;
